import {z} from 'zod'

export type RecommendationId = `rec-${string}`
export const RecommendationId = z.string().startsWith('rec-') as z.ZodType<RecommendationId>
